import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { Button, Container, Paper } from '@material-ui/core';
import { fetchGlobalPricing, storeGlobalPricing } from '../../reducers/pricing';
import CustomizeFees from '../../components/CustomizeFees';
import UpdateReasonForm from '../../components/UpdateReasonForm';
import { showEntityChangelogs } from '../../reducers/entityChangelogs';
import Changelog from '../../components/Changelog';

const Index = () => {
  const dispatch = useDispatch();
  const original = useSelector(state => state.pricing.global);
  const [data, setData] = useState(null);
  const showChangelogs = () => {
    dispatch(showEntityChangelogs(1, 'Pricing', 'global_pricing'));
  };

  const handleOnSave = reason => {
    dispatch(storeGlobalPricing({ ...data, reason }));
  };

  useEffect(() => {
    if (!original) {
      dispatch(fetchGlobalPricing());
    } else {
      setData(cloneDeep(original));
    }
  }, [original, dispatch]);

  if (!data) {
    return '';
  }

  // eslint-disable-next-line react/prop-types
  const ActionWrapper = ({ children }) => {
    return (
      <div>
        <Button onClick={showChangelogs} variant="contained" color="primary" style={{}}>
          Show Changelogs
        </Button>
        {children}
      </div>
    );
  };

  return (
    <Container maxWidth="md">
      <Changelog />
      <Paper>
        <UpdateReasonForm>
          {({ open }) => (
            <CustomizeFees
              fees={data}
              originalFees={original}
              defaultFees={{}}
              onSave={() => open(reason => handleOnSave(reason))}
              onChange={setData}
              ActionWrapper={ActionWrapper}
            />
          )}
        </UpdateReasonForm>
      </Paper>
    </Container>
  );
};

export default Index;
